import { Box, FormControl, Typography } from '@mui/material'
import {
    CalendarIcon,
    DatePicker,
    LocalizationProvider,
} from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { getDate } from '../../utils/DateAndTimeUtils'
import { ReactElement } from 'react'

interface DateInputProps {
    id: string
    label: string
    value: string
    onChange: any
    errorMessage?: string
    required?: boolean
    disabled?: boolean
    clearable?: boolean
}

const DateInput = (props: DateInputProps): ReactElement => {
    const {
        id,
        label,
        value,
        onChange,
        errorMessage = '',
        required,
        disabled,
        clearable,
    } = props

    const onChangeDate = (val: any) => {
        const utcDate = val ? getDate(val) : ''

        onChange(id, utcDate)
    }

    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth disabled={!!disabled}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography sx={{ opacity: '0.7', fontSize: '14px' }}>
                        {label}
                        {required ? '*' : ''}
                    </Typography>
                    <DatePicker
                        reduceAnimations
                        className="custom-date-picker"
                        slotProps={{
                            textField: {
                                id: id + '-input',
                                size: 'small',
                                error: errorMessage !== '',
                                sx: {
                                    '& div': {
                                        fontSize: '14px',
                                    },
                                    '& button': {
                                        padding: '5px',
                                    },
                                    '.clearButton': {
                                        display: 'none',
                                        padding: '0px',
                                    },
                                    '&:hover': {
                                        '.clearButton': {
                                            display: 'flex',
                                        },
                                    },
                                    '& input, & span': {
                                        fontSize: '14px',
                                        opacity:
                                            value !== '' &&
                                            value !== 'MM/DD/YYYY' &&
                                            value !== null
                                                ? '1'
                                                : '0.7',
                                    },
                                },
                                fullWidth: true,
                                helperText: errorMessage,
                            },
                            field: {
                                id: id + '-field',
                                clearable,
                            },
                        }}
                        slots={{
                            openPickerIcon: (props) => (
                                <CalendarIcon
                                    {...props}
                                    id={id + '-calendar-open-icon'}
                                />
                            ),
                        }}
                        value={dayjs(value)}
                        onChange={(newValue) => onChangeDate(newValue)}
                        sx={{
                            marginTop: '50px',
                            fontSize: '14px',
                        }}
                        disabled={!!disabled}
                    />
                </LocalizationProvider>
            </FormControl>
        </Box>
    )
}

export default DateInput
